import $ from 'jquery';

$( document ).ready( function() {
	$( '#changelog .title' ).click( function() {
		$( '#changelog' ).toggleClass( 'open' );
		$( '#changelog .log' ).slideToggle();
	} );
} );
